import React from "react";
import { createContext } from "../../helpers/createContext";
import { normalize } from "../../helpers/normalize";
import useAuth from "../../routes/login/AuthContext";
import {GetIntegrationsMappings, IIntegrationsMappings} from "../../services/IntegrationApi";

interface IIntegrationContext {
  integrations: IIntegrationsMappings[];
  importEnabled: boolean;
  accApi: boolean;
  kineticApi: boolean;
  loadIntegrations: (id: number) => Promise<void>;
}

const [IntegrationContext, useIntegrationContext] = createContext<IIntegrationContext>();

export const IntegrationProvider: React.FC = (props) => {
  const { getAuthToken } = useAuth();
  const [integrations, setIntegrations] = React.useState<IIntegrationsMappings[]>([]);
  const [importEnabled, setImportEnabled] = React.useState<boolean>(false);
  const [accApi, setAccApi] = React.useState<boolean>(false);
  const [kineticApi, setKineticApi] = React.useState<boolean>(false);

  const loadIntegrations = async (id: number) => {
    const response = await GetIntegrationsMappings(id, await getAuthToken());
    if (response) {
      setIntegrations(response?.mappings as IIntegrationsMappings[] || []);
      setImportEnabled(response.importEnabled);
      response?.accApi ? setAccApi(response.accApi) : setAccApi(false);
      response?.kineticApi ? setKineticApi(response.kineticApi) : setKineticApi(false);
    }

    return;
  };

  const value = React.useMemo(
    () => ({
      accApi,
      kineticApi,
      importEnabled,
      loadIntegrations,
      integrations,
    }),
    [normalize(integrations), accApi, kineticApi, importEnabled]
  );

  return <IntegrationContext.Provider value={value} {...props} />;
};

export { useIntegrationContext };
